import React, { useEffect, useMemo, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { useLanguage } from "../../i18n/LanguageContext";
import "./Terminal.css";

export function Terminal() {
  const { t } = useLanguage();
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  const lines = useMemo(
    () => [
      { cmd: t.terminal.whoamiCmd, out: t.terminal.whoamiOut },
      { cmd: t.terminal.focusCmd, out: t.terminal.focusOut },
      { cmd: t.terminal.buildingCmd, out: t.terminal.buildingOut },
      { cmd: t.terminal.statusCmd, out: t.terminal.statusOut },
    ],
    [t.terminal]
  );

  const [visibleCount, setVisibleCount] = useState(0);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    setVisibleCount(0);
    setCharCount(0);
  }, [lines]);

  useEffect(() => {
    if (!inView || visibleCount >= lines.length) return;
    const currentCmd = lines[visibleCount].cmd;

    if (charCount < currentCmd.length) {
      const timeout = setTimeout(() => setCharCount((c) => c + 1), 32);
      return () => clearTimeout(timeout);
    }
    const timeout = setTimeout(() => {
      setVisibleCount((v) => v + 1);
      setCharCount(0);
    }, 520);
    return () => clearTimeout(timeout);
  }, [inView, visibleCount, charCount, lines]);

  return (
    <div className="terminal" ref={ref}>
      <div className="terminal__bar">
        <span className="terminal__dot terminal__dot--red" />
        <span className="terminal__dot terminal__dot--yellow" />
        <span className="terminal__dot terminal__dot--green" />
        <span className="terminal__title mono">{t.terminal.title}</span>
      </div>
      <div className="terminal__body mono">
        {lines.slice(0, visibleCount).map((line, i) => (
          <div className="terminal__line" key={i}>
            <p className="terminal__cmd">
              <span className="terminal__prompt">$</span> {line.cmd}
            </p>
            <p className="terminal__out">{line.out}</p>
          </div>
        ))}
        {visibleCount < lines.length && (
          <p className="terminal__cmd">
            <span className="terminal__prompt">$</span> {lines[visibleCount].cmd.slice(0, charCount)}
            <span className="terminal__caret" />
          </p>
        )}
      </div>
    </div>
  );
}
